import ARMRemoteApi from '../../../remote-api/ARMRemoteApi'
import { Application, ARMApplicationDetail } from '../../../remote-api/models'

export class ResourceSelectorService {

  private readonly remoteAPI: ARMRemoteApi

  constructor(remoteAPI: ARMRemoteApi) {
    this.remoteAPI = remoteAPI
  }

  public fetchApplicationData(orgId: string, envId: string, appName: string): Promise<ARMApplicationDetail> {
    return this.remoteAPI.fetchApplicationData(orgId, envId, appName)
  }

  public fetchCloudhubApplications(orgId: string, envId: string, apps: Application[]): Promise<Application[]> {
    return Promise.all(apps.map(app => this.fetchApplicationData(orgId, envId, app.id.split('.')[0])))
      .then(arrayOfAppDetails => [].concat.apply(
        [],
        arrayOfAppDetails.map(app => {
          const previousApp = apps.find(application => application.id === app.fullDomain)
          return {...previousApp, muleVersion: app.muleVersion.version}
        })
      ) as Application[])
  }

  public fetchRTFApplications(orgId: string, envId: string, apps: Application[]): Promise<Application[]> {
    return Promise.all(apps.map(app => this.remoteAPI.fetchRTFData(orgId, envId, app.id)))
      .then(arrayOfAppDetails => [].concat.apply(
        [],
        arrayOfAppDetails.map(app => {
          const previousApp = apps.find(application => application.id === app.id)
          return {...previousApp, muleVersion: app.target.deploymentSettings ? app.target.deploymentSettings.runtimeVersion : ''}
        })
      ) as Application[])
  }

  public fetchHybridApplications(orgId: string, envId: string, apps: Application[]): Promise<Application[]> {
    return Promise.all(apps.map(app => this.remoteAPI.fetchHybridData(orgId, envId, app.hybridId ? app.hybridId.toString() : app.id.toString())))
      .then(arrayOfAppDetails => [].concat.apply(
        [],
        arrayOfAppDetails.map(app => {
          const previousApp = apps.find(application => application.hybridId === app.data.id.toString())
          return {...previousApp, muleVersion: app.data.target.muleVersion}
        })
      ) as Application[])
  }

}
